<template>
  <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="选择供应商"
      class="customer-edit"
      width="80%"
      top="5vh">
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="supplierInfoes">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="编号">
            <el-input v-model.trim="filter.no" clearable/>
          </vm-search>
          <vm-search label="名称">
            <el-input v-model.trim="filter.name" clearable/>
          </vm-search>
          <vm-search label="外部编号">
            <el-input v-model.trim="filter.outerNO" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="no" label="编号"/>
      <el-table-column prop="name" label="名称"/>
      <el-table-column prop="outerNO" label="外部编号"/>
      <el-table-column prop="shortName" label="简称"/>
      <el-table-column prop="shortCode" label="缩写"/>
      <el-table-column prop="contact" label="联系人"/>
      <el-table-column prop="mobile" label="手机号"/>
      <el-table-column label="操作" align="center" width="90px">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="onSelect(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";


  export default {
    name:"SupplierManageSelect",
    components: {VmTable,VmSearch},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        filter: {
          no: "",
          name: "",
          outerNO: "",
          shortName: "",
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      onSelect(row) {
        this.$emit("select", row);
        this.dialogVisible = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
